import { Sparkles } from 'lucide-react';

// Sanctuary-themed Suspense fallback. Soft violet background, gold sparkle glow,
// and the calm copy "Opening the sanctuary..."
export const SanctuaryLoading = () => (
  <div
    data-testid="sanctuary-loading"
    className="min-h-screen relative overflow-hidden flex items-center justify-center"
    style={{
      background:
        'radial-gradient(ellipse at top, rgba(60, 36, 110, 0.55) 0%, rgba(8, 4, 20, 1) 60%)',
    }}
  >
    {/* Soft cosmic mist */}
    <div className="cosmic-mist absolute inset-0 pointer-events-none opacity-50 z-0" />
    <div className="stardust-layer absolute inset-0 pointer-events-none z-0" />

    <div className="relative z-10 text-center px-6">
      <div className="sanctuary-loading-aura mx-auto mb-8 flex items-center justify-center">
        <Sparkles
          className="text-[var(--accent-gold)] animate-float-gentle relative z-10"
          size={32}
        />
      </div>
      <p
        className="font-['Cormorant_Garamond'] text-xl md:text-2xl italic text-[var(--text-accent)] glow-text-gold tracking-wide"
        style={{ animation: 'welcome-fade-in 1.4s ease-out both' }}
      >
        Opening the sanctuary…
      </p>
      <div className="mt-6 mx-auto w-16 h-px bg-gradient-to-r from-transparent via-[var(--accent-gold)] to-transparent opacity-50" />
    </div>
  </div>
);

export default SanctuaryLoading;
